import React from "react"
import { CheckCircleIcon, XCircleIcon, XIcon } from "@heroicons/react/outline"
import * as ToastPrimitive from "@radix-ui/react-toast"
import cx from "clsx"
import { AnimatePresence, motion } from "framer-motion"
import Show from "components/Show"
import useToasts from "hooks/useToasts"

const Toasts = () => {
  const { toasts, dismissToast } = useToasts()

  return (
    <ToastPrimitive.Provider>
      <AnimatePresence initial={false}>
        {toasts.map(toast => {
          if (toast.dismissed) return null

          return (
            <ToastPrimitive.Root
              key={toast.id}
              asChild
              forceMount
              open={!toast.dismissed}
            >
              <motion.li
                key={toast.id}
                layout
                initial={{ opacity: 0, x: `100%`, scale: 1, height: `auto` }}
                animate={{ opacity: 1, x: `0%`, scale: 1, height: `auto` }}
                exit={{ opacity: 0, x: `100%`, height: `auto` }}
                transition={{
                  type: `spring`,
                  mass: 1,
                  damping: 25,
                  stiffness: 300
                }}
                className="overflow-hidden"
              >
                <div
                  className={cx(
                    `relative py-3 pl-3 mt-2 border rounded-lg flex items-start w-80 max-w-full`,
                    {
                      "bg-black border-black text-white":
                        toast.type === `success`,
                      "bg-[#fdf5f5] border-secondary-red text-black":
                        toast.type === `error`,
                      "pr-3": !toast.closable,
                      "pr-8": toast.closable
                    }
                  )}
                >
                  <div className="mr-3">
                    <Show when={toast.type === `success`}>
                      <CheckCircleIcon className="w-6 h-6" aria-hidden="true" />
                    </Show>

                    <Show when={toast.type === `error`}>
                      <XCircleIcon className="w-6 h-6" aria-hidden="true" />
                    </Show>
                  </div>

                  <ToastPrimitive.Description className="text-base">
                    {toast.message}
                  </ToastPrimitive.Description>

                  <Show when={toast.closable}>
                    <ToastPrimitive.Close
                      className="absolute top-2 right-2"
                      onClick={() => {
                        dismissToast(toast.id)
                      }}
                      aria-label="Close"
                    >
                      <XIcon className="w-6 h-6 z-10" aria-hidden="true" />
                    </ToastPrimitive.Close>
                  </Show>
                </div>
              </motion.li>
            </ToastPrimitive.Root>
          )
        })}
      </AnimatePresence>

      <ToastPrimitive.Viewport className="[--viewport-padding:_32px] fixed bottom-0 right-0 flex flex-col p-[var(--viewport-padding)] w-96 max-w-[100vw] m-0 list-none z-[2147483647] overflow-visible" />
    </ToastPrimitive.Provider>
  )
}

export default Toasts
